import React from 'react';

// ChoiceChips — tappable replies under the NPC's current line.
//
// Ported contract, not ported code: the website's chat already does this
// (ChatService.sendMessageWithChoices writes `metadata.choices`, AvatarChatModal
// renders them, a tap submits `value` as if the player typed it). The dialogue
// director is stateless and thread-less, so the storage half doesn't apply —
// but the SHAPE does, `{ label, value }`, and keeping it identical means an NPC
// offering choices on the phone and one offering them on the website are the
// same feature rather than two that drift.
//
// The website disables tapped buttons and highlights the chosen one because its
// messages persist and re-render. Here the tapped value becomes the player's own
// bubble in the transcript a moment later, which says the same thing better — so
// these just clear.
export default function ChoiceChips({ choices, onPick, disabled, compact = false }) {
  if (!Array.isArray(choices) || choices.length === 0) return null;
  return (
    <div style={{
      display: 'flex', flexWrap: 'wrap', gap: compact ? 6 : 8,
      alignSelf: 'flex-start', maxWidth: '100%',
      padding: compact ? '2px 0 0' : '2px 0 0',
    }}>
      {choices.map((c, i) => (
        // SWATCH choices (Khari, 2026-08-03: "you should show the color
        // circles there") — a choice carrying `swatch` renders as the same
        // color circle the avatar editor uses: the disc IS the option, the
        // tiny label names it. Everything else stays a text chip.
        c.swatch ? (
          <button
            key={`${c.value}-${i}`}
            onClick={() => onPick(c.value, c.label)}
            disabled={disabled}
            title={c.label}
            style={{
              display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 3,
              background: 'none', border: 'none', padding: 2,
              cursor: disabled ? 'default' : 'pointer', opacity: disabled ? 0.45 : 1,
            }}
          >
            <span style={{
              width: compact ? 26 : 32, height: compact ? 26 : 32, borderRadius: '50%',
              background: c.swatch, border: '2px solid rgba(255,233,196,0.35)',
              boxShadow: '0 2px 8px rgba(0,0,0,0.4)',
            }} />
            <span style={{
              font: `600 ${compact ? 8.5 : 9.5}px system-ui`, color: '#ffd9a6',
              maxWidth: 56, textAlign: 'center', lineHeight: 1.15,
            }}>{c.label}</span>
          </button>
        ) : (
          <button
            key={`${c.value}-${i}`}
            onClick={() => onPick(c.value, c.label)}
            disabled={disabled}
            title={c.value}
            style={{
              padding: compact ? '7px 12px' : '9px 15px',
              borderRadius: 999, cursor: disabled ? 'default' : 'pointer',
              border: '1px solid rgba(255,178,94,0.5)',
              background: 'rgba(255,178,94,0.14)', color: '#ffd9a6',
              font: `700 ${compact ? 12 : 13.5}px system-ui`,
              opacity: disabled ? 0.45 : 1, textAlign: 'left',
            }}
          >{c.label}</button>
        )
      ))}
    </div>
  );
}
